function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';
import PropTypes from 'prop-types';
import { CircularProgress, Dialog as MUIDialog, DialogContent, makeStyles, withMobileDialog } from '@material-ui/core';
const useStyles = makeStyles(theme => ({
  loading: {
    display: 'flex',
    justifyContent: 'center',
    padding: theme.spacing(3)
  },
  paper: {
    [theme.breakpoints.up('sm')]: {
      minWidth: 400
    }
  }
}));

const Dialog = ({
  children,
  loading,
  onClose,
  ...props
}) => {
  const classes = useStyles();
  return React.createElement(MUIDialog, _extends({
    transitionDuration: 500,
    classes: {
      paper: classes.paper
    },
    onClose: e => {
      e.stopPropagation();
      onClose(e);
    }
  }, props), loading ? React.createElement(DialogContent, {
    className: classes.loading
  }, React.createElement(CircularProgress, null)) : children);
};

Dialog.propTypes = {
  loading: PropTypes.bool,
  onClose: PropTypes.func.isRequired
};
export default withMobileDialog()(Dialog);